import { createSlice } from '@reduxjs/toolkit';
import { createExtraReducersForThunk, createApiThunkPrivate } from '../_helpers/ApiThunk';

const initialState = {
    getDeliveryData: {}, getAllDeliveryPartnerListData: {}
}

export const create = createApiThunkPrivate('create', '/delivery/partner-create', 'POST')
export const update = createApiThunkPrivate('update', '/delivery/partner-update ', 'POST')
export const softDelete = createApiThunkPrivate('softDelete', '/delivery/partner-delete', 'DELETE')
export const enableDisable = createApiThunkPrivate('enableDisable', '/delivery/partner-enable-disable', 'POST')
export const getDelivery = createApiThunkPrivate('getDelivery', '/delivery/partner-getList', 'GET', true)

export const getAllDeliveryPartnerList = createApiThunkPrivate('getAllDeliveryPartnerList', '/delivery/partner-getAllDocument', 'GET', true)
export const deliveryStatus = createApiThunkPrivate('deliveryStatus', '/delivery/delivery-status', 'POST')




const deliveryPartnerSlice = createSlice({
    name: 'delivery',
    initialState,
    extraReducers: builder => {
        createExtraReducersForThunk(builder, getDelivery, 'getDeliveryData')
        createExtraReducersForThunk(builder, getAllDeliveryPartnerList, 'getAllDeliveryPartnerListData')


    }
})

export default deliveryPartnerSlice.reducer